import appGlobalScript from '/Users/Shared/Development/Sites/ojp-elements/src/global/global.js';
export const globalScripts = appGlobalScript;
